/**
 * Form schema
 * @param {object} data
 * @param {object} data.response (SERVER ONLY)
 * @returns {object}
 */
export const formSchema = ({ response }) => {
	const data = {
		taxIdentifier: null,
		nationalId: {
			value: {
				formatted: '',
				unformatted: ''
			},
			type: '' // CPF or CNPJ
		},
		installments: 3,
		phoneNumber: ''
	};
	if (IS_SERVER) {
		const { region, regionConfig, sessionStore } = response.locals;
		data.defaultCountry = region.toUpperCase();
		data.fallbackCountry = regionConfig.fallbackCountry;
		data.initial = sessionStore?.store.form?.initial;
		data.creditCard = null;
		data.directDebit = null;
	}
	return data;
};
